export const concernLevelColorMap = {
  'concern-hazard': '#972600',
  'concern-recommendation': '#FF8B6A',
  'concern-maintenance': '#476177',
};
